export default {
      id: "manager-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#manager",
      toString: function () {
        return this.url;
      }
    }